import { iconLibrary } from '@/shared/icons';
import { DbResetType } from '@/shared/stores/db/enums';
import { userState } from '@/user-home/state/user';
import type { Task } from '@/types/tasks';

export const twwChores11_2_0: Task = {
    key: 'twwChores11_2_0',
    name: '[TWW] 11.2.x',
    shortName: '11.2',
    minimumLevel: 80,
    showSeparate: true,
    chores: [
        {
            key: 'twwWarrant',
            name: 'Warrant',
            accountWide: true,
            questReset: DbResetType.Weekly,
            questIds: [
                90122, // Eliminate Xy'vox the Twisted
                90123, // Eliminate Hollowbane
                90124, // Eliminate Shatterpulse
                90125, // Eliminate Purple Peat
                90126, // Eliminate Grubber
                90127, // Eliminate Arcana-Monger So'zer
            ],
        },
        {
            key: 'twwReshanor',
            name: 'World Boss',
            accountWide: true,
            icon: iconLibrary.emojiZzz,
            questReset: DbResetType.Weekly,
            questResetForced: true,
            questIds: [87352],
        },
        {
            key: 'twwMoreThanPhase',
            name: 'More Than Just a Phase',
            icon: iconLibrary.mdiSwimDive,
            questReset: DbResetType.Weekly,
            questIds: [91093],
        },
        {
            key: 'twwKareshSpecial',
            name: 'Special Assignment',
            icon: iconLibrary.gameScrollQuill,
            showQuestName: true,
            questReset: DbResetType.Weekly,
            subChores: [
                {
                    key: 'unlock',
                    name: 'World Quests',
                    questResetForced: true,
                    questIds: [
                        91193, // Overshadowed Unlock
                        91203, // Aligned Views Unlock
                    ],
                },
                {
                    key: 'assignment',
                    name: 'Assignment',
                    alwaysStarted: true,
                    questResetForced: true,
                    questIds: [
                        89293, // Overshadowed
                        89294, // Aligned Views
                    ],
                },
            ],
        },
        {
            key: 'twwEcologicalSuccession',
            name: 'Ecological Succession',
            icon: iconLibrary.gameBearFace,
            questReset: DbResetType.Weekly,
            // questResetForced: true,
            questIds: [85460],
            couldGetFunc: () => userState.quests.anyCharacterHasById.has(85262), // The Royal Procession
        },
        {
            key: 'twwMakingDeposit1',
            name: 'Anima: Atrium',
            // maybe these need to be subChores?
            questIds: [89062], // Devourer Attack: The Atrium
            questReset: DbResetType.Weekly,
        },
        {
            key: 'twwMakingDeposit2',
            name: 'Anima: Eco-dome',
            questIds: [89061], // Devourer Attack: Eco-dome: Primus
            questReset: DbResetType.Weekly,
        },
        {
            key: 'twwMakingDeposit3',
            name: 'Anima: Oasis',
            questIds: [85722], // Devourer Attack: The Oasis
            questReset: DbResetType.Weekly,
        },
        {
            key: 'twwMakingDeposit4',
            name: 'Anima: Tazavesh',
            questIds: [89063], // Devourer Attack: Tazavesh
            questReset: DbResetType.Weekly,
        },
    ],
};
